/*
 * Copyright (C) Luna Srl - All Rights Reserved
 *
 * @project    bfree-frontend.nosync
 * @file       PublicImage.tsx
 * @author     Christian Ascone
 * @date       9/23/19 1:22 PM
 */

import React from 'react';
import {Image} from "react-native";

export function PublicImage(props) {
    return (
        <Image
            {...props}
            style={[props.style]}
            source={
                require('../../../assets/images/public.png')
            }
        />
    );
}